import * as yup from 'yup';

export const productCategorySchema = yup.object({
  categoryName: yup.string().required('Category name is required'),
  existingCategoryId: yup.string().optional(),
});

export type ProductCategoryFormData = yup.InferType<
  typeof productCategorySchema
>;
